import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-chevron-right",
  "use": "icon-chevron-right-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" id=\"icon-chevron-right\"><path d=\"m7.354 11.354-.708-.708L9.293 8 6.646 5.354l.708-.708L10.707 8z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol